import Cookies from "../lib/cookies";
import { getString } from "../lib/localization";

export const ALL_CATEGORIES = "all";
export const CATEGORY_REQUIRED = "req-jwfmzd";

const categories = {
   [CATEGORY_REQUIRED]: {
      label: getString("cookieConsent.category.required"),
      required: true
   }
};

window.addEventListener("DOMContentLoaded", () => includeAllAcceptedScripts());

export function getSettings() {
   const settings = {};

   Object.keys(categories).forEach((key) => {
      settings[key] = Cookies.get(getCookieNameOfCategory(key)) === "true";
   });

   return Object.keys(settings).length > 0 ? settings : null;
}

export function settingsComplete() {
   let complete = true;
   Object.keys(categories).forEach((key) => {
      if (Cookies.get(getCookieNameOfCategory(key)) === null) {
         complete = false;
      }
   });
   return complete;
}

function getCookieNameOfCategory(category) {
   return category.toLowerCase();
}

function createSettingsExpirationDate() {
   let t = Date.now();
   t += 86400 * 1000 * 365;
   return new Date().setTime(t);
}

function includeScriptsOfCategory(category) {
   const elements = Array.from(
      document.querySelectorAll('[data-cookieconsent-category="' + category + '"]')
   );

   const ignoreAttributes = ["type", "data-src", "data-cookieconsent-category"];

   elements.forEach(function (inactiveElement) {
      if (inactiveElement.tagName === "SCRIPT") {
         const src = inactiveElement.getAttribute("data-src");
         const activeElement = document.createElement("script");

         // Copy text
         activeElement.textContent = inactiveElement.innerHTML;

         // Copy attributes
         const numberAttributes = inactiveElement.attributes.length;
         for (let i = 0; i < numberAttributes; i++) {
            const attribute = inactiveElement.attributes[i];

            if (!ignoreAttributes.includes(attribute.nodeName)) {
               activeElement.setAttribute(
                  attribute.nodeName,
                  attribute.nodeValue
               );
            }
         }

         // Copy data-src to src
         if (src) {
            activeElement.src = src;
         }

         activeElement.type = "text/javascript";

         inactiveElement.parentNode.replaceChild(
            activeElement,
            inactiveElement
         );
      }
   });

   return this;
}

function includeAllAcceptedScripts() {
   Object.keys(categories).forEach(key => {
      if (hasAccepted(key)) {
         includeScriptsOfCategory(key);
      }
   });
}

export function setAcceptGroup(category, accept) {
   const cookieValue = accept === true ? "true" : "false";

   if (category === "*" || category === ALL_CATEGORIES) {
      Object.keys(categories).forEach(key => {
         Cookies.set(
            getCookieNameOfCategory(key),
            cookieValue,
            createSettingsExpirationDate()
         );
      });
   } else {
      const categories = category.split(/[\s,]+/g);
      categories.forEach(function (categoryItem) {
         Cookies.set(
            getCookieNameOfCategory(categoryItem),
            cookieValue,
            createSettingsExpirationDate()
         );
      });
   }
   if (accept === true) {
      includeScriptsOfCategory(category);
   }
}

export function hasAccepted(category) {
   return Cookies.get(
      getCookieNameOfCategory(category)
   ) === "true";
}

export function addCategory(key, data) {
   categories[key] = data;

   if (hasAccepted(key)) {
      includeScriptsOfCategory(key);
   }
}

export function getCategories() {
   return categories;
}

export function acceptRequired() {
   Object.keys(categories).forEach(key => setAcceptGroup(key, key === CATEGORY_REQUIRED));
}

export function acceptAll() {
   Object.keys(categories).forEach(key => setAcceptGroup(key, true));
}
